
import { defineComponent } from "vue";
import { generateFollowUpMessage } from "@/api/aiAgents.api.js";
import { exceedsSocialWindow } from "@/utils/followUpPolicy.js";
import ContentMediaLibrary from "@/components/social/ContentMediaLibrary.vue";

const DEFAULT_STEP = () => ({
  delayMinutes: 15,
  useLlm: true,
  message: "",
  llmHint: "",
  mediaIds: [] as number[]
});

export default defineComponent({
  name: "ai-agent-follow-up-panel",
  components: {
    ContentMediaLibrary
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    agentId: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedScenario: "contactStoppedReplying",
      generatingIndex: null as number | null,
      scenarioItems: [
        { key: "contactStoppedReplying", label: "Conversation in-activity", disabled: false }
      ]
    };
  },
  computed: {
    scenarios(): any {
      return this.modelValue;
    },
    activeScenario(): any {
      return this.scenarios[this.selectedScenario] || this.scenarios.contactStoppedReplying;
    },
    windowWarning() {
      if (!this.activeScenario || !this.activeScenario.steps || !this.activeScenario.steps.length) {
        return "";
      }
      if (exceedsSocialWindow(this.activeScenario.steps)) {
        return "Total follow-up delays exceed 20 hours. Facebook, Instagram, and WhatsApp may block messages sent outside the messaging window.";
      }
      return "";
    }
  },
  methods: {
    stepMediaIds(step: any) {
      return Array.isArray(step.mediaIds) ? step.mediaIds : [];
    },
    hasStepMedia(step: any) {
      return this.stepMediaIds(step).length > 0;
    },
    onUseLlmChange(step: any) {
      if (step.useLlm) {
        step.mediaIds = [];
      } else if (!Array.isArray(step.mediaIds)) {
        step.mediaIds = [];
      }
    },
    selectScenario(item: any) {
      if (item.disabled) return;
      this.selectedScenario = item.key;
    },
    onScenarioEnabledChange(key: string) {
      const scenario = this.scenarios[key];
      if (scenario.enabled && !scenario.steps.length) {
        scenario.steps.push(DEFAULT_STEP());
      }
    },
    addStep() {
      if (this.activeScenario.steps.length >= 5) return;
      this.activeScenario.steps.push(DEFAULT_STEP());
    },
    removeStep(index: number) {
      this.activeScenario.steps.splice(index, 1);
    },
    updateStepMediaIds(index: number, mediaIds: number[]) {
      this.activeScenario.steps[index].mediaIds = mediaIds;
    },
    async generateMessage(index: number) {
      if (!this.agentId) return;
      this.generatingIndex = index;
      try {
        const step = this.activeScenario.steps[index];
        const response = await generateFollowUpMessage(this.agentId, {
          llmHint: step.llmHint || step.message || undefined
        });
        this.activeScenario.steps[index].message = response.data?.message || "";
      } catch (err) {
        console.error(err);
      } finally {
        this.generatingIndex = null;
      }
    }
  }
});
